// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
// @todo: Migrate to 'Dialog.Modal' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as Dialog from '@wandb/weave/components/Dialog';
import React from 'react';

type ConfirmRegistryAccessModalProps = {
  isOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  onClickConfirm: () => void;
  onClickCancel: () => void;
  disableButtons?: boolean;
};

export const ConfirmRegistryAccessModal = ({
  isOpen,
  setIsModalOpen,
  onClickConfirm,
  onClickCancel,
  disableButtons,
}: ConfirmRegistryAccessModalProps) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsModalOpen}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content
          className="w-[600px] rounded-lg"
          onInteractOutside={e => {
            e.preventDefault();
          }}>
          <Dialog.Title>
            Changing registry visibility to 'restricted'
          </Dialog.Title>
          <Dialog.Description
            className="pt-16"
            data-test="update-access-summary">
            If you change the registry's visibility to 'restricted', uninvited
            organization members will lose access to this registry immediately.
          </Dialog.Description>
          <Dialog.Description className="pt-16">
            Are you sure you want to continue?
          </Dialog.Description>
          <div className="mb-8 mt-24 flex items-center">
            <Button
              data-test="delete-all-button"
              variant="primary"
              disabled={disableButtons}
              size="large"
              onClick={onClickConfirm}>
              Change to restricted
            </Button>
            <Dialog.Close className="ml-8">
              <Button
                className="dark:text-moon-200/100 dark:filter-none hover:dark:text-moon-200"
                variant="ghost"
                size="large"
                disabled={disableButtons}
                onClick={onClickCancel}>
                Cancel
              </Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
